import moment from "moment-timezone";
import { Lock } from "lucide-react";
import { Badge } from "../../../../../../components/ui/badge";
import Checkbox from "../../../../../../components/Inputs/Checkbox";
import BreakOvertimeIndicator from "../../BreakOvertimeIndicator";
import SectionInfo from "../../SectionInfo";
import { getSectionDurations } from "../../../helpers/data/getSectionDurations";
import { renderSectionsDuration } from "../../../helpers/eventdisplay/renderSectionsDuration";

function Content({
    event,
    preferenceStyle,
    checked,
    showCheckbox,
    onEventChange
}: any) {
    const { overtimeDuration, breakDuration } = getSectionDurations(event?.sections);

    return (
        <>
            <div className="tw-w-full">
                <div className="tw-flex tw-flex-col">
                    <div className="tw-flex tw-items-center tw-justify-between">
                        <div className="tw-font-bold tw-text-xs tw-flex tw-items-center tw-gap-1">
                            {event?.locked && (<Lock size={12} strokeWidth={3} className="tw-mb-1" />)}
                            {renderSectionsDuration(
                                moment(event.endDate).diff(moment(event.startDate), "seconds"),
                                event.sections
                            )}
                        </div>

                        <BreakOvertimeIndicator
                            breakDuration={breakDuration}
                            overtimeDuration={overtimeDuration}
                        />
                    </div>

                    <SectionInfo
                        section={event?.sections?.[0]}
                        className="tw-pt-0.5"
                    />
                </div>
            </div>

            {showCheckbox && (
                <div
                    onClick={(e) => e.stopPropagation()}
                    onDoubleClick={(e) => e.stopPropagation()}
                >
                    <Checkbox
                        id={event.id}
                        checked={checked}
                        className="tw-bg-white"
                        onChange={onEventChange}
                    />
                </div>
            )}
            <Badge
                className="
                    tw-absolute -tw-top-1 -tw-right-1
                    tw-min-w-5 tw-h-5
                    tw-flex tw-items-center tw-justify-center
                    tw-rounded-full tw-px-0
                "
                style={{ background: preferenceStyle.borderLeftColor }}
            >
                {event?.slots || 1}
            </Badge>
        </>
    );
}

export default Content;
